import styles from './Card.module.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'none';
}

export function Card({ children, className, padding = 'md' }: CardProps) {
  return (
    <div className={[styles.card, styles[`pad-${padding}`], className ?? ''].join(' ')}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={[styles.header, className ?? ''].join(' ')}>{children}</div>;
}

export function CardBody({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={[styles.body, className ?? ''].join(' ')}>{children}</div>;
}
